import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class Footer extends Component {
	render() {
		return (
			<div className="section-body">
				<footer className="footer">
					<div className="container-fluid">
						<div className="row">
							<div className="col-md-6 col-sm-12">
								Copyright © {new Date().getFullYear()} <a
									href="https://gleads.vn/vi">Gleads</a>.
                            </div>
						</div>
					</div>
				</footer>
			</div>
		);
	}
}
